import React from 'react';

function ReportBreakPage() {
  return <div style={{ pageBreakBefore: 'always' }}></div>;
}

export default ReportBreakPage;
